<template>
  <div class="productDetails">
    <banner title="炫碟系列" />
    <div class="productDetails-section" v-loading="loading">
      <div class="productDetails-section-content" @click="handleNavClick">
        <div class="content-nav">
          <div
                  class="content-nav-btn"
                  :class="{'content-nav-active':newstype == 1}"
                  @click="newstype = 1"
          >
            <span>火龙果催花灯</span>
          </div>
          <div
                  class="content-nav-btn"
                  :class="{'content-nav-active':newstype == 2}"
                  @click="newstype = 2 "
          >
            <span>农光互补</span>
          </div>

        </div>

      </div>
      <div v-show="newstype === 1">
        <div class="productDetails-l-section" v-loading="loading">
          <div class="productDetails-l-section-content">
            <div class="productDetails-l-section-content-list" v-for="(cas,index) in caseList" :key="index">
              <img :src="getImageUrl(cas.img)" />
            </div>
          </div>
        </div>
      </div>
      <div v-show="newstype === 2">
        <div class="productDetails-l-section" v-loading="loading">
          <div class="productDetails-l-section-content">
            <div class="productDetails-l-section-content-list" v-for="(cas,index) in caseList" :key="index">
              <img :src="getImageUrl(cas.img)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Banner from "../../components/Banner";
  import product_xd_1 from '../../assets/img/product/product_xd_1.jpg';
  import product_xd_2 from '../../assets/img/product/product_xd_2.jpg';
  import product_xd_3 from '../../assets/img/product/product_xd_3.jpg';
  import product_xd_4 from '../../assets/img/product/product_xd_4.jpg';
  import product_xd_ng_1 from '../../assets/img/product/product_xd_ng_1.jpg';
  import product_xd_ng_2 from '../../assets/img/product/product_xd_ng_2.jpg';
  import product_xd_ng_3 from '../../assets/img/product/product_xd_ng_3.jpg';
  import product_xd_ng_4 from '../../assets/img/product/product_xd_ng_4.jpg';

  export default {
    name: "NewsDetails",
    components: {
      Banner
    },
    data() {
      return {
        pid: 1,
        caseList: [],
        newstype: 1,
        loading: true  // 添加loading属性并初始化
      };
    },
    created() {
      // this.pid = this.$route.params.id;
      // this.newstype = this.pid;
      // this.loadData();
    },
    mounted() {
      this.loadData();
      // this.$http
      //         .get("Cases/GetCasesAll")
      //         .then(response => {
      //           //console.log(response);
      //           this.caseList = [
      //             {Id: 1, Title: "冰火系列",img:'冰火系列'},
      //             {Id: 2, Title: "混光催花灯",img:'混光催花灯'},
      //             {Id: 3, Title: "飞瀑系列",img:'飞瀑系列'},
      //           ];
      //           //window.console.log(this.caseList);
      //           this.loading = false;
      //         })
      //         .catch(function(error) {
      //           window.console.log(error);
      //         });
    },
    methods: {
      handleNavClick() {
        if (this.newstype ===1){
          this.caseList = [
            {Id: 1, Title: "炫碟系列-催花",img:'product_xd_1'},
            {Id: 2, Title: "炫碟系列-催花",img:'product_xd_2'},
            {Id: 3, Title: "炫碟系列-催花",img:'product_xd_3'},
            {Id: 4, Title: "炫碟系列-催花",img:'product_xd_4'},
          ];
        } else  if (this.newstype ===2){
          this.caseList = [
            {Id: 1, Title: "炫碟系列-农光互补",img:'product_xd_ng_1'},
            {Id: 2, Title: "炫碟系列-农光互补",img:'product_xd_ng_2'},
            {Id: 3, Title: "炫碟系列-农光互补",img:'product_xd_ng_3'},
            {Id: 4, Title: "炫碟系列-农光互补",img:'product_xd_ng_4'},
          ];
        }
        this.loading = false;
      },
      getImageUrl(img) {
        switch (img) {
          case 'product_xd_1':
            return product_xd_1;
          case 'product_xd_2':
            return product_xd_2;
          case 'product_xd_3':
            return product_xd_3;
          case 'product_xd_4':
            return product_xd_4;
          case 'product_xd_ng_1':
            return product_xd_ng_1;
          case 'product_xd_ng_2':
            return product_xd_ng_2;
          case 'product_xd_ng_3':
            return product_xd_ng_3;
          case 'product_xd_ng_4':
            return product_xd_ng_4;
          default:
            return ''; // 默认图片路径
        }
      },
      loadData() {
        switch (this.newstype) {
          case 1:
            this.caseList = [
              {Id: 1, Title: "炫碟系列-催花",img:'product_xd_1'},
              {Id: 2, Title: "炫碟系列-催花",img:'product_xd_2'},
              {Id: 3, Title: "炫碟系列-催花",img:'product_xd_3'},
              {Id: 4, Title: "炫碟系列-催花",img:'product_xd_4'},
            ];
            break;
          case 2:
            this.caseList = [
              {Id: 1, Title: "炫碟系列-农光互补",img:'product_xd_ng_1'},
              {Id: 2, Title: "炫碟系列-农光互补",img:'product_xd_ng_2'},
              {Id: 3, Title: "炫碟系列-农光互补",img:'product_xd_ng_3'},
              {Id: 4, Title: "炫碟系列-农光互补",img:'product_xd_ng_4'},
            ];
            break;
        }
        this.loading = false; // 设置 loading 为 false
      },
    }
  };
</script>

<style lang="scss" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .productDetails {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
    &-section {
      width: 100%;
      //height: 1600px;

      &-content {
        width: 30%;
        //height: 1600px;
        margin: 0 auto;
        background-color: #fff;
        /*border: 1px solid red;*/

        .content-nav {
          width: 80%;
          height: 55px;
          margin: 0 auto;
          display: flex;
          //justify-content: center;
          align-items: center;
          position: relative;
          bottom: 30px;
          /*border: 1px solid red;*/

          &-btn {
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #e4e4e4;
            transition: all 0.2s;
          }

          .content-nav-active {
            background-color: rgb(195,35,61);
            color: #fff;
          }
        }

        .content-nav-item {
          width: 88%;
          margin: 0 auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          //border: 1px solid blue;

        }
      }
    }
    .productDetails-l {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      background-color: #14679f;
      &-section {
        width: 100%;
        &-content {
          height: 100%;
          width: 100%;
          /*min-height: 1000px;*/
          margin: 0 auto;
          background-color: #fff;

          &-list {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            /*border: 1px solid pink;*/
            img {
              width: 70%;
              height: 100%;
            }
            .abstract-active {
              order: -1;
            }
          }
        }
      }
    }
  }
</style>
